module.exports = __webpack_public_path__ + "img/restaurant.ca673b35.svg";